import React from "react";
import PropTypes from "prop-types";
import TextInfo from "@/bit/components/components.text";
import Image from "@/bit/components/components.c-image";
import Carousel from "@/bit/components/components.carousel";
import Button from "@/bit/components/components.button";
import CustomLink from "@/bit/components/components.custom-link";

const RecomCharacteristics = (props) => {
  const cardKeys = Object.keys(props).filter((key) => /^Card-\d+$/.test(key));
  const cardValues = cardKeys.map((key) => props[key]);
  const isWebView = process.env.NEXT_PUBLIC_WEB_VIEW === "true";

  return (
    <>
      <section
        className="recom-characterisctics container"
        data-cy="Section RecomCharacterisctics"
      >
        <hr className="separator" />
        {props["Text-1"] && props["Text-1"].text && (
          <div className="recom-characterisctics--title">
            <TextInfo
              {...props["Text-1"]}
              kind="h"
              level="2"
              cyData="RecomCharacteristics Title"
            />
          </div>
        )}
        {props["Text-2"] && props["Text-2"].text && (
          <div className="recom-characterisctics--title">
            <TextInfo
              {...props["Text-2"]}
              kind="h"
              level="2"
              cyData="RecomCharacteristics Title"
            />
          </div>
        )}
        {cardValues && Array.isArray(cardValues) && cardValues.length > 0 && (
          <div
            className="recom-characterisctics--content"
            data-cy="RecomCharacterisctics Content"
          >
            <Carousel
              className={props.carouselClassName || ""}
              maxPointNum={0}
              breakpoint={768}
            >
              {cardValues.map((charac, index) => (
                <div
                  className="recom-characterisctics--item"
                  key={`recom-characterisctics--${index}`}
                  data-cy="RecomCharacterisctics Card"
                >
                  <div className="recom-characterisctics--item--image">
                    <Image
                      fill
                      objectFit="cover"
                      {...charac["Image-1"]}
                      cyData="RecomCharacteristics Image-1"
                    />
                  </div>
                  <div className="recom-characterisctics--item--text">
                    <div className="recom-characterisctics--item--container-text">
                      {charac["Text-1"] && (
                        charac["CustomLink-1"] ? (
                          <CustomLink {...charac["CustomLink-1"]}>
                            <TextInfo
                              {...charac["Text-1"]}
                              kind="h"
                              level="3"
                              className="recom-characterisctics--item--title"
                              cyData="RecomCharacteristics Text-1"
                            />
                          </CustomLink>
                        ) : (
                          <TextInfo
                            {...charac["Text-1"]}
                            kind="h"
                            level="3"
                            className="recom-characterisctics--item--title"
                            cyData="RecomCharacteristics Text-1"
                          />
                        )
                      )}
                      {charac["Text-2"] && (
                        <TextInfo
                          {...charac["Text-2"]}
                          className="recom-characterisctics--item--description"
                          cyData="RecomCharacteristics Text-2"
                        />
                      )}
                    </div>
                    {charac["Button-1"] &&
                      !isWebView &&
                      charac["Button-1"].label && (
                        <div className="recom-characterisctics--item--button">
                          <Button
                            {...charac["Button-1"]}
                            className="button-more-info"
                            cyData="RecomCharacteristics Button-1"
                            taggingInfo={{
                              componentName: "recom-characterisctics",
                              componentVariation: "all",
                              componentContent: charac["Button-1"].label,
                              eventType: "click",
                            }}
                          />
                        </div>
                      )}
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        )}
      </section>
      <style jsx>{`
        .recom-characterisctics {
          display: flex;
          flex-direction: column;
          padding-bottom: 0.5rem;
          &--title {
            margin-bottom: 1rem;
            margin-top: 1rem;
          }
          &--content {
            width: 100%;
          }
          :global(.carousel) {
            :global(.carousel-window) {
              gap: 1rem;
            }
          }
          &--item {
            display: flex;
            flex-direction: column;
            height: 100%;
            border-radius: 16px;
            overflow: hidden;
            border: 1px solid #dddddd;
            width: min(20.9vw, 352px);
            &--container-text {
              :global(a) {
                cursor: default;
              }
            }
            &--text {
              padding: 1rem;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              height: 100%;
              gap: 8px;
              :global(.recom-characterisctics--item--title) {
                margin-bottom: 0.3rem;
              }
            }
            &--image {
              position: relative;
              min-height: 13.5rem;
              width: 100%;
            }
            &--button {
              :global(.button-more-info) {
                padding: 0 0;
                justify-content: flex-start;
              }
              :global(.button-more-info):hover {
                color: #80cef9 !important;
              }
            }
          }
          hr.separator {
            color: #dddddd;
            margin-top: 2rem;
            margin-bottom: 1rem;
          }
          @media screen and (max-width: 1024px) {
            .recom-characterisctics {
              &--item {
                width: 20rem;
              }
            }
          }
        }
      `}</style>
    </>
  );
};

RecomCharacteristics.propTypes = {};

RecomCharacteristics.defaultProps = {};

export default RecomCharacteristics;
